import { CustomTypedEvent } from '../events';
export class AnimationEvent extends CustomTypedEvent {
    constructor(args) {
        super("step", args);
    }
}
export class AnimationEndEvent extends CustomEvent {
    constructor() {
        super('end');
    }
}
export class AnimationStartEvent extends CustomEvent {
    constructor() {
        super('start');
    }
}
//}
